import apiClient from './apiClient'

export function searchDistrict(keywords, subdistrict) {
  return apiClient.get('https://restapi.amap.com/v3/config/district', {
    params: {
      keywords,
      subdistrict,
      key: '99908a6d0c2f7cc8df7064a414e86b2c'
    }
  })
}

export function getDistrictCenterList() {
  return apiClient.get(
    'https://bucket-resources.oss-cn-qingdao.aliyuncs.com/config/pc_owner/districts.json'
  )
}

export async function depcratedGetSearchTipsTencent(payload, keyword) {
  const res = await apiClient.get('/amap/depcrated/assistant/inputtips', {
    params: {
      location: payload?.latitude
        ? `${payload?.longitude},${payload?.latitude}`
        : '',
      region: payload?.region || '',
      keyword
    },
    baseURL: process.env.AGILE_API_URL
  })
  return res.data
}
